// extracted by mini-css-extract-plugin
module.exports = {"modal":"styles_modal__l_yu5","header":"styles_header__2576I"};